import address from "../../../../../assets/img/location.png";
import phone from "../../../../../assets/img/phone.png";
import whatsapp from "../../../../../assets/img/whatsapp.png";
import email from "../../../../../assets/img/email.png";
import style from "./Info.module.css";

const Info = () => {

    return(
        <div className={style.info}>
            <h3>Dónde estamos</h3>
            <div>
                <p><img src={address} alt=""/><a href="https://maps.app.goo.gl/foY3YX8G7Ber6PGs9" target="_blank" rel="noopener noreferrer">Calle 50 n° 1615 e/ 27 y 28, La Plata, Buenos Aires</a></p>
                <p><img src={phone} alt=""/><a href="tel:+542214514239" target="_blank" rel="noopener noreferrer">(0221) 451-4239</a>&nbsp;/&nbsp;<a href="tel:+542214576973" target="_blank" rel="noopener noreferrer">(0221) 457-6973</a>&nbsp;/&nbsp;<a href="tel:+542214531179" target="_blank" rel="noopener noreferrer">(0221) 453-1179</a></p>
                <p><img src={whatsapp} alt=""/><a href="https://wa.me/542216954484" target="_blank" rel="noopener noreferrer">(221) 695-4484</a></p>
                <p><img src={email} alt=""/><a href="mailto:ventas.electroplat@gmail.com" target="_blank" rel="noopener noreferrer">ventas.electroplat@gmail.com</a></p>
            </div>           
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3270.910018131363!2d-57.970655799999996!3d-34.933793599999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a2e794c9cb8b53%3A0x164a5857ac897ad1!2sElectroplat!5e0!3m2!1ses!2sar!4v1756323761310!5m2!1ses!2sar"
                width="100%"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Electroplat"
            >
            </iframe>
        </div>
    );
};

export default Info;